import { api } from '../../api-helper';
import { URLS } from '../../../constants/URLS';

export const getUserPreferences = () => {
  return api.get(URLS.userPreferences, {
    headers: {
      needsToken: true
    }
  });
};

export const updateUserPreferences = (preferences) => {
  return api.put(URLS.userPreferences, preferences, {
    headers: {
      needsToken: true
    }
  });
};
